import { render, staticRenderFns } from "./ReportLowProduct.vue?vue&type=template&id=a5517cd0&"
import script from "./ReportLowProduct.vue?vue&type=script&lang=js&"
export * from "./ReportLowProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports